import { ReactElement } from 'react';
import translation from '../../../../../languages';
import BundleMaterialCardWithAddToCart from '../../../../material-page/standalone-material/two-column-desc-bund/components/bundle-material-card-with-add-to-cart/bundle-material-card-with-add-to-cart';
import useAddBundleToCart from '../../hooks/use-add-bundle-to-cart';
import './cart-item-bundles.scss';

type CartItemBundlesProps = TranslationProps & { bundles: Material[] };

const CartItemBundles = ({ t, bundles }: CartItemBundlesProps): ReactElement => {
    const addBundleToCart = useAddBundleToCart();

    return (
        <>
            <h5 className='item-bundles-title'>{t('cart:cart.cartItems.itemBundlesTitle')}:</h5>
            <div className='item-bundles'>
                {bundles.map((item, index) => (
                    <BundleMaterialCardWithAddToCart
                        key={item.id}
                        material={item}
                        materialIndex={index}
                        {...addBundleToCart}
                    />
                ))}
            </div>
        </>
    );
};

const translate = translation('cart');

export default translate(CartItemBundles);
